export const SET_MAIN_FOOTER_ACTIVE = 'concrete/SET_MAIN_FOOTER_ACTIVE'
export const SET_MAIN_FOOTER_EXIT = 'concrete/SET_MAIN_FOOTER_EXIT'



// WEBPACK FOOTER //
// ./src/components/main/action-types.js